import { createSvgIcon } from "@mui/material";

export const PulseIconLogo = createSvgIcon(
<svg id="pulse-icon" data-name="Pulse Icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.82 19.82">
  <g>
    <path d="M4.1,0H0v4.27h4.04c7.42,0,13.44,6.02,13.44,13.44v2.11h2.34v-4.1C19.82,7.04,12.78,0,4.1,0Z"/>
    <path d="M2.52,7.81H0v4.27h2.54c3.71,0,6.71,3.01,6.71,6.71v1.03h2.34v-2.94c0-5.01-4.06-9.08-9.08-9.08Z"/>
  </g>
</svg>);